export default "__VITE_ASSET__d73bce84__"